import React from 'react';

export default function AssistantSlashMenu({
  open,
  items,
  activeIndex,
  onSelect,
  onHover,
}) {
  if (!open || items.length === 0) {
    return null;
  }

  return (
    <ul className="assistant-slash-menu" role="listbox" aria-label="Skills">
      {items.map((skill, index) => (
        <li key={skill.slug}>
          <button
            type="button"
            role="option"
            aria-selected={index === activeIndex}
            className={`assistant-slash-menu__item${index === activeIndex ? ' is-active' : ''}`}
            onMouseEnter={() => onHover?.(index)}
            onMouseDown={(event) => {
              event.preventDefault();
              onSelect(skill);
            }}
          >
            <span className="assistant-slash-menu__slug">/{skill.slug}</span>
            <span className="assistant-slash-menu__nom">{skill.nom}</span>
            <span className="assistant-slash-menu__desc">{skill.description}</span>
          </button>
        </li>
      ))}
    </ul>
  );
}
